export const SCHOOLS_ROUTES = {
	schools: "/app/schools",
} as const;
